<template lang="pug">
  .main-wrapper
    router-view
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.main-wrapper {
  flex: 1;
  padding: 3% 5%;
  text-align: left;
}
</style>
